import _ from "lodash";
import { useEffect, useState } from "react"


const useFetch = ( fn, { variables = {} } = {} ) => {

    const [ loading, setLoading ] = useState( false );
    const [ data, setData ] = useState( null );
    const [ error, setError ] = useState( null );

    const onCallbackStart = () => {
        setLoading( true );
        setData( null );
        setError( null );
    }

    const onCallbackSuccess = ( data ) => {
        setLoading( false );
        setData( _.cloneDeep( data ) );
    }

    const onCallbackError = ( error ) => {
        setLoading( false );
        setError( error );
    }

    const fetch = () => {
        if( typeof fn === 'function' ) {
            fn({
                callbackStart: onCallbackStart,
                callbackSuccess: onCallbackSuccess,
                callbackError: onCallbackError,
                variables: variables,
            });
        }
    }

    useEffect( () => {
        fetch()
    }, [] );

    return {
        loading,
        data,
        error,
        refetch: fetch,
    }
}

export default useFetch